(() => {
  const groupTimbers = (library) => {
    const timberHeading = library.querySelector('#FomuMaterial-timber');
    if (!timberHeading || library.dataset.timberGrouped === 'true') return;

    const groups = [];
    let node = timberHeading.nextElementSibling;
    while (node && !node.classList.contains('fomu-material-library__division-heading')) {
      if (node.classList.contains('fomu-material-library__group')) groups.push(node);
      node = node.nextElementSibling;
    }

    const cards = groups.flatMap((group) => [...group.querySelectorAll('.fomu-material-library__card')]);
    const species = [
      ['American Oak', /^American Oak(?:\s|$)/i],
      ['American Ash', /^American Ash(?:\s|$)/i],
      ['Tasmanian Oak', /^Tasmanian Oak(?:\s|$)/i],
      ['American Walnut', /^(?:American )?Walnut(?:\s|$)/i]
    ];

    const buckets = new Map(species.map(([name]) => [name, []]));
    const other = [];

    cards.forEach((card) => {
      const title = card.querySelector('h3')?.textContent?.trim() || '';
      const match = species.find(([, pattern]) => pattern.test(title));
      if (!match) {
        other.push(card);
        return;
      }

      const speciesName = match[0];
      const isPlainTimberCard = title.localeCompare(speciesName, undefined, { sensitivity: 'accent' }) === 0 ||
        (speciesName === 'American Walnut' && title.localeCompare('Walnut', undefined, { sensitivity: 'accent' }) === 0);

      if (isPlainTimberCard) {
        card.remove();
        return;
      }

      buckets.get(speciesName).push(card);
    });

    groups.forEach((group) => group.remove());

    const fragment = document.createDocumentFragment();
    const makeGroup = (name, items) => {
      if (!items.length) return;
      const section = document.createElement('section');
      section.className = 'fomu-material-library__group fomu-material-library__timber-species';
      const id = `FomuMaterial-timber-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
      section.setAttribute('aria-labelledby', id);
      const heading = document.createElement('h2');
      heading.id = id;
      heading.textContent = name;
      const intro = document.createElement('p');
      intro.className = 'fomu-material-library__group-intro';
      intro.textContent = 'Available finishes / colours';
      const grid = document.createElement('div');
      grid.className = 'fomu-material-library__grid';

      items.sort((a, b) => {
        const aTitle = a.querySelector('h3')?.textContent?.trim() || '';
        const bTitle = b.querySelector('h3')?.textContent?.trim() || '';
        const rank = (title) => /\braw\b/i.test(title) ? 0 : /\bnatural\b/i.test(title) ? 1 : /\bwarm\b/i.test(title) ? 2 : /\bblack\b/i.test(title) ? 3 : 4;
        return rank(aTitle) - rank(bTitle) || aTitle.localeCompare(bTitle);
      });

      items.forEach((card) => {
        const title = card.querySelector('h3');
        if (title) {
          const original = title.textContent.trim();
          title.dataset.fullMaterialName = original;
          const prefix = name === 'American Walnut' ? /^(?:American )?Walnut\s*/i : new RegExp(`^${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*`, 'i');
          title.textContent = original.replace(prefix, '') || 'Timber';
        }
        grid.appendChild(card);
      });
      section.append(heading, intro, grid);
      fragment.appendChild(section);
    };

    species.forEach(([name]) => makeGroup(name, buckets.get(name)));
    makeGroup('Other Timbers', other);
    timberHeading.after(fragment);
    library.dataset.timberGrouped = 'true';
  };

  const run = () => document.querySelectorAll('.fomu-material-library').forEach(groupTimbers);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();